<template>
  <div style="background:#f6f7fa;">
    <Header></Header>
    <div class="mt-3 mb-3">
      <div class="container p-2">
        <section
          class="news_content"
          style="margin: 0px; padding:3rem 4rem; overflow: hidden; color: rgb(51, 51, 51);  text-align:left; background-color:#FFF;"
        >
          <h3
            style="margin-bottom:2rem; padding-bottom:1rem;font-size: 28px; font-weight: lighter; text-align: center; border-bottom: 1px solid rgb(138, 172, 220);"
          >
            高等教育出版社简介
          </h3>
          <pre
            style=" line-height:2; white-space: pre-wrap; overflow-wrap: break-word;"
          >    高等教育出版社（以下简称高教社）成立于1954年5月，是新中国最早设立的专业教育出版机构之一。1960年4月，与人民教育出版社合并。1965年1月，与人民教育出版社分立，恢复建制。1972年1月，随同教育部一起被撤销。1972年7月，与人民教育出版社合并重建。1983年5月，重新恢复建制，邓小平同志为高教社题写社名。
          <br />    高教社现有在职员工1700余人，拥有全国文化名家暨“四个一批”人才、全国新闻出版行业领军人才、韬奋出版奖获得者、中国出版政府奖获得者等一批行业领军人才。年出书万余种，发行近1.3亿册。出版社规模、员工数量居国内出版社前列。
          <br />    经过65年的发展，高教社已经成为以出版普通高等教育、职业教育、继续教育等教育类和专业学术类出版物为主的大型综合性出版社，产品形态覆盖图书、音像制品、电子出版物、网络出版物、期刊、数字化教学平台及服务、教师培训等。获得中国出版政府奖、中华优秀出版物奖、“五个一工程”奖、全国优秀教材奖、国家级教学成果奖、国家科学技术进步奖等重要奖项。先后被评为“全国优秀出版社”“全国先进出版单位”“全国百佳图书出版单位”，是唯一获得世界知识产权组织“世界知识产权组织创意金奖——单位奖”，唯一入围全球50强的中国单体出版机构。综合实力处于中国出版行业领先地位，具有广泛知名度和国际影响力。
          <br />    高教社一直是高等教育、职业教育国家规划教材出版的主要承担者。高教社出版的教材，高等教育类图书市场占有率25%，高等职业教育类图书市场占有率20%，中等职业教育类图书市场占有率33%，均居全国出版社之首。
          <br />    在教育部的领导下，高教社承担了全国高校思想政治工作网、中国大学生在线两个网站的建设和运营工作，主动服务教育部党组工作部署，不断拓展高校思政教育新阵地。目前思政网已覆盖各省级党委教育工作部门、75所教育部直属高校和其他部委高校、2500所地方高校。中国大学生在线网站会员总数已达到1120万人，再创历史新高。已形成以思政网、中国大学生在线、高校思政工作队伍培训中心、高校辅导员网络培训中心“两网两中心”为核心，以官方微博、微信、QQ空间、在线喜马拉雅音频、抖音短视频等11个移动新媒体为支撑的思政工作矩阵，覆盖面、影响力进一步扩大。
          <br />    高教社主题出版、学术出版规模不断扩大，产品结构日趋合理，出版物研发与国家各类重要科研和出版项目相结合，形成了精品产品线。出版了一大批研究阐发习近平总书记系列重要讲话精神，庆祝“改革开放40年”“新中国成立70年”“建党100年”等精品力作，多次入选各类国家主题出版重点出版物、国家规划重点出版项目。主办、合办包括《思想理论教育导刊》《中国大学教学》《中国外语》《中国编辑》《马克思主义理论学科研究》及“前沿”系列英文学术期刊（28种）等各类期刊48种，形成了学术期刊群，其中28种“前沿”系列英文学术期刊中的13种被SCI收录，5种被Ei收录，2019年入选“中国科技期刊卓越行动计划”集群化试点1项、重点期刊1项、梯队期刊6项。期刊规模和影响力位居国内前列，在服务高校学科专业建设和人才培养，展示中国学术、传播中国声音方面发挥了重要作用。
          <br />    高教社大力开展出版业务转型升级，推动融合发展，取得显著成效。传统教材与在线开放课程、在线资源库融合，推出了一大批资源丰富、互联互动、特色鲜明的新形态教材，在高等教育、职业教育教材建设中起到了引领作用。新形态教材在出版总码洋中的占比逐年提升，约占40％－45％，达到国际先进教育出版机构的水平。高教社不断探索开展在线教育、教师培训服务、考试服务等新业务，积极拓展教育出版服务产业链，现已形成“爱课程”“智慧职教”“教师网络培训中心”“虚拟仿真实验教学平台—实验空间”“高校考试培训网络学院”等多个最具影响力的在线教育服务平台网站。
          <br />    在国际化方面，高教社与包括众多知名出版商在内的全球200多家机构开展广泛的合作，24个语种版本的国际型产品在世界60多个国家发行，版权输出数量在全国单体出版社中连年名列前茅。连续多次被评为国家文化出口重点企业。
          <br />    党的十九大胜利召开，全国人民在党的领导下迈入中国特色社会主义新时代。高教社将全面学习宣传贯彻习近平新时代中国特色社会主义思想和党的十九大及十九届历次全会精神，把握正确政治方向和出版导向，把社会效益放在首位，实现社会效益和经济效益相统一。以融合发展为主线，以拓展延伸为突破，以创新驱动为先导，以人才支撑为保障，加快推进数字化融合发展，推出更多精品力作，满足日益增长的教育、文化需求。加快在线教育、网络培训等新业务发展，更好地服务教育，把高教社建设成为主业挺拔、服务多元、产品领先、管理科学的国际知名教育出版机构，有国际影响力的学术出版机构，国内领先的教育服务机构，努力书写新时代中国特色社会主义教育出版事业发展新篇章。</pre>
        </section>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Header from "../components/header";
import Bottom from "../components/bottom";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Bottom,
  },
};
</script>

<style>
@import url("../assets/style.css");
@import url("../assets/bootstrap.css");
pre {
  font-size: 100%;
  text-align: justify;
}
</style>
